'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _style = require('./style.scss');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Loading = function Loading() {
  return _react2.default.createElement(
    'div',
    { className: _style2.default['page-cover'] },
    _react2.default.createElement(
      'div',
      { className: _style2.default['uil-spin-css'] },
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('div', null)
      ),
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('div', null)
      ),
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('div', null)
      ),
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('div', null)
      ),
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('div', null)
      ),
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('div', null)
      ),
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('div', null)
      ),
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('div', null)
      )
    )
  );
};

exports.default = Loading;


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/Loading/Loading.js
// module id = 1351
// module chunks = 0